import { HomePage } from "./style";

export function Home() {
  return (
    <HomePage>
      {/* <!-- 头部导航 --> */}
      <header>
        <div className="container header-container">
          <div className="logo">
            <h1>Ton一键发币</h1>
          </div>
          <nav>
            <ul>
              <li>
                <a href="#features">功能特点</a>
              </li>
              <li>
                <a href="#process">发币流程</a>
              </li>
              <li>
                <a href="#faq">常见问题</a>
              </li>
              <li>
                <a href="#contact">联系我们</a>
              </li>
            </ul>
          </nav>
          <a href="#create" className="cta-button">
            立即发币
          </a>
        </div>
      </header>

      <section className="hero" id="home">
        <div className="container">
          <div className="hero-content">
            <h1>
              TON<span>一键发币</span>，<br />
              3分钟创建您的专属代币
            </h1>
            <p>无需编程经验，无需复杂配置，BananaTool提供最简单快捷的TON区块链发币解决方案。</p>
            <div className="hero-buttons">
              <a href="#create" className="cta-button">
                立即创建TON代币
              </a>
              <a href="#features" className="secondary-button">
                了解详情
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="process" id="process">
        <div className="container">
          <div className="section-title">
            <h2>TON代币创建只需4步</h2>
            <p>简单直观的操作流程，快速完成代币部署</p>
          </div>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>连接钱包</h3>
              <p>使用Tonkeeper或Tonhub连接您的TON钱包</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>设置代币</h3>
              <p>输入代币名称、符号、总量等基本信息</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>确认支付</h3>
              <p>支付少量TON作为矿工费和平台服务费</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>部署完成</h3>
              <p>智能合约部署成功，代币创建完成</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section" id="create">
        <div className="container">
          <h2>立即创建您的TON代币</h2>
          <p>超过10,000个代币项目通过BananaTool成功部署到TON区块链，加入他们开启您的代币之旅！</p>
          <a href="#" className="cta-button">
            开始创建代币
          </a>
        </div>
      </section>

      <section className="faq" id="faq">
        <div className="container">
          <div className="section-title">
            <h2>常见问题解答</h2>
            <p>关于TON一键发币的常见问题</p>
          </div>
          <div className="faq-container">
            <div className="faq-item">
              <div className="faq-question">
                <span>创建TON代币需要多少费用？</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                <p>
                  创建TON代币的费用主要包括两部分：区块链Gas费和平台服务费。Gas费由TON网络决定，通常在0.05-0.1
                  TON之间。平台服务费为0.5 TON。总计约0.55-0.6 TON即可完成代币创建。
                </p>
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>需要编程知识才能创建TON代币吗？</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                <p>
                  完全不需要！BananaTool的一键发币平台设计得非常简单易用，您只需要填写代币的基本信息（名称、符号、总量等），剩下的技术工作由我们的平台自动完成。无需任何编程或区块链开发经验。
                </p>
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>代币创建后如何管理？</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                <p>
                  代币创建完成后，您可以通过BananaTool的管理后台进行以下操作：
                  <br />
                  - 查看代币基本信息
                  <br />
                  - 执行代币转账
                  <br />
                  - 进行批量空投
                  <br />
                  - 冻结/解冻代币
                  <br />
                  - 查看交易历史和持币地址
                  <br />
                  所有管理操作都设计为简单直观的界面，无需编写代码。
                </p>
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>创建代币需要多长时间？</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                <p>
                  整个代币创建过程非常快速：
                  <br />
                  1. 信息填写：1-2分钟
                  <br />
                  2. 交易确认：TON区块链通常1-2秒即可确认交易
                  <br />
                  3. 合约部署：3-5秒
                  <br />
                  总计不超过5分钟，您就可以拥有自己的TON区块链代币！
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer id="contact">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column">
              <h3>BananaTool</h3>
              <p>TON区块链一站式工具平台，提供一键发币、批量转账、资产管理等专业服务。</p>
              <div className="social-links">
                <a href="#">
                  <span>📱</span>
                </a>
                <a href="#">
                  <span>🐦</span>
                </a>
                <a href="#">
                  <span>💬</span>
                </a>
                <a href="#">
                  <span>📘</span>
                </a>
              </div>
            </div>
            <div className="footer-column">
              <h3>快速链接</h3>
              <ul className="footer-links">
                <li>
                  <a href="#home">首页</a>
                </li>
                <li>
                  <a href="#features">功能特点</a>
                </li>
                <li>
                  <a href="#process">发币流程</a>
                </li>
                <li>
                  <a href="#faq">常见问题</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3>工具产品</h3>
              <ul className="footer-links">
                <li>
                  <a href="#">TON一键发币</a>
                </li>
                <li>
                  <a href="#">批量转账工具</a>
                </li>
                <li>
                  <a href="#">代币空投工具</a>
                </li>
                <li>
                  <a href="#">持币地址分析</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3>联系我们</h3>
              <ul className="footer-links">
                <li>客服微信: BananaTool</li>
                <li>Telegram: @Bananatool_support</li>
                <li>邮箱: support@bananatool.com</li>
                <li>商务合作: bd@bananatool.com</li>
              </ul>
            </div>
          </div>
          <div className="copyright">
            <p>&copy; 2023 BananaTool TON Tool - TON一键发币平台,TON批量转账工具。保留所有权利。</p>
          </div>
        </div>
      </footer>
    </HomePage>
  );
}
